<div class="modal-container">
  <div class="header flex_sb">
    <div class="header-text">
      <ng-container *ngIf="openedFrom === 'splitbill'">
        {{
          splitBillData?.guest_name +
            ' ' +
            ('SETTLE_BILL.BILL_DETAILS' | fallbackTranslate) ||
            'ORDER_DASHBOARD.GUEST' +
              ' ' +
              (this.data.index + 1) +
              'SETTLE_BILL.BILL_DETAILS' | fallbackTranslate
        }}
      </ng-container>
      <ng-container *ngIf="openedFrom !== 'splitbill'">
        <ng-container
          *ngIf="
            openedFrom === 'orderstab' || openedFrom === 'tables-layout';
            else others
          "
        >
          {{ 'SETTLE_BILL.MERGE_BILL' | fallbackTranslate }}
        </ng-container>
        <ng-template #others>
          {{ 'ORDER_DASHBOARD.PAYMENT_PENDING' | fallbackTranslate }}
        </ng-template>
      </ng-container>
      <div class="fs-16 fw-400 clr-333" *ngIf="billingCounterName" [innerHTML]="billingCounterInfo"></div>
    </div>
    <div class="cross" (click)="closeDialog()">
      <img [src]="images.CROSS" alt="close" />
    </div>
  </div>
  <div class="container-section">
    <nz-spin [nzSpinning]="isLoading">
      <ng-container *ngFor="let item of allDataList">
        <mat-expansion-panel
           class="panel-class"
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title>
              <div>
                {{ 'ORDER_DASHBOARD.ORDER' | fallbackTranslate }} #{{
                  item?.details?.orderno
                }}
                <div>
                  <span class="order-info">
                    {{ item?.details?.name | titlecase }}'s
                    {{ 'ORDER_DASHBOARD.ORDER' | fallbackTranslate }}-
                  </span>
                  <span class="order-info">
                    {{ item?.details?.ordercount }} x
                    {{ 'ORDER_DASHBOARD.QTY' | fallbackTranslate }}
                  </span>
                </div>
              </div>
            </mat-panel-title>
            <mat-panel-description>
              <div style="color: #212b44; font-weight: 600; text-align: right">
                {{ Currency }} {{ item?.details?.balance_text || item?.details?.balance }}
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div>
            <app-order-list [items]="item.items"></app-order-list>
          </div>
          <div>
            <app-total-amount
              [amount]="item.amount"
              [details]="item?.details"
            ></app-total-amount>
          </div>
        </mat-expansion-panel>
      </ng-container>
    </nz-spin>

    <div class="amount-tbp-div m-b-16" *ngIf="grandTotal > 0">
      <div class="flex_sb">
        <div class="flex-row-lc text-payment-tbp" style="padding-left: 10px">
          {{ 'SETTLE_BILL.GRAND_TOTAL' | fallbackTranslate }}
        </div>
        <div class="flex-row-rc text-amount-tbp" style="padding-right: 10px">
          {{ Currency }} {{ format.formatNo(grandTotal) }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="grandTotal > 0">
      <app-payment-options
        [showUnionExperience]="!!data?.showUnionExperience"
        [showQris]="data.showQris"
        [showDuitnow]="data.showDuitnow"
        [showPineLab]="data.showPineLab"
        [amount]="grandTotal"
        (name)="paymentName($event)"
        (channel)="paymentChannel($event)"
        (t_id)="transactionIdChange($event)"
        (cashDetails)="cashTransactionDetail($event)"
        [paymentInputDisabled]="isPaymentAmtInputDisabledForOfflineMethods"
        [mergedOrderIds]="mergedOrderIds"
      ></app-payment-options>
    </ng-container>

  </div>
  <div class="flex modal-action" style="align-items: center">
    <button
      nz-button
      nzSize="large"
      (click)="printBill()"
      class="print-button fw-600 fs-16  m-r-20"
      [disabled]="!canTriggerKioskPrint"
    >
      <img class="img-24" [src]="images.PRINT" alt="print" />
      <p class="print-text">{{ 'SETTLE_BILL.PRINT' | fallbackTranslate }}</p>
    </button>
    <button
      class="wd-100 collect-payment"
      nz-button
      nzSize="large"
      (click)="paymentDoneClicked()"
      [disabled]="!(currentPaymentChannel && grandTotal > 0)"
    >
      <ng-container
        *ngIf="
          openedFrom == 'orderstab' || openedFrom == 'tables-layout';
          else other
        "
      >
        {{ 'SETTLE_BILL.MERGE_BILL' | fallbackTranslate }}
      </ng-container>
      <ng-template #other>
        {{
          'SETTLE_BILL.COLLECT_PAYMENT' | fallbackTranslate
        }}
      </ng-template>
    </button>
  </div>
</div>

<!-- Print Bill Template -->

<div id="finalBill">
  <div class="border" style="padding: 4px" *ngIf="printData?.type == 'receipt'">
    <div class="rest_details">
      <strong *ngFor="let item of printData?.header">
        <p>{{ item }}</p>
      </strong>
      <!-- <p>{{ rest_address }}</p> -->
      <p class="bold">{{ 'TABLES.INVOICE' | fallbackTranslate | uppercase }}</p>
    </div>
    <div class="order_details">
      <p>
        {{ 'TABLES.TABLE' | fallbackTranslate }}:
        <span class="bold">{{ printData?.body?.Table }}</span>
      </p>
      <p>
        {{ 'ORDER_DASHBOARD.INVOICE_NO' | fallbackTranslate }}:
        {{ printData?.body?.Invoice_No }}
      </p>
      <p>{{ 'GLOBAL.DATE' | fallbackTranslate }}:{{ printData?.body?.Date }}</p>
      <p *ngIf="printData?.body?.Cashier != ''">
        {{ 'ORDER-TYPE.CASHIER' | fallbackTranslate }}:{{ printData?.body?.Cashier }}
      </p>
    </div>

    <table>
      <tbody>
        <tr>
          <th width="50%" align="left">
            {{ 'CREATE_NEW_ORDER.ITEMS' | fallbackTranslate }}
          </th>
          <th width="20%" align="left">
            {{ 'CREATE_NEW_ORDER.PRICE' | fallbackTranslate }}
          </th>
          <th width="10%" align="left">
            {{ 'CREATE_NEW_ORDER.QTY' | fallbackTranslate }}
          </th>
          <th width="20%" align="left">
            {{ 'CREATE_NEW_ORDER.AMT' | fallbackTranslate }}
          </th>
          <th></th>
        </tr>

        <tr *ngFor="let item of printData?.order?.items; let i = index">
          <td width="50%" align="left">
            {{ item.name }}
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.variant != ''"
            >
              {{ 'ORDER_DASHBOARD.VARIANTS' | fallbackTranslate }}
              <p>{{ item.variant }}</p>
            </div>
            <div
              class="addons_variants_text"
              style="font-size: 9px !important"
              *ngIf="item.addon != ''"
            >
              {{ 'CREATE_NEW_ORDER.ADDONS' | fallbackTranslate }}
              <p>{{ item.addon }}</p>
            </div>
          </td>
          <td width="20%" align="left">
            {{ item.price }}
          </td>
          <td width="10%" align="left">{{ item.qty }}</td>
          <td width="20%" align="left">{{ item.amount }}</td>
        </tr>
      </tbody>
    </table>
    <hr class="hr-line"/>

    <table>
      <tbody>
        <tr *ngFor="let item of printData?.order?.bill">
          <td width="50%" align="left" style="font-size: 12px">
            {{ item.name }}
          </td>
          <td width="50%" align="left" style="font-size: 12px">
            <span *ngIf="isNumber(item.value)">
              {{ printData?.order?.currency }} {{ item.value }}
            </span>
            <span *ngIf="!isNumber(item.value)">{{ item.value }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="hr-line"/>
    <div
      class="thank"
      style="text-align: center; margin-bottom: 20px; font-weight: 700"
    >
      {{ 'ORDER_DASHBOARD.THANK_YOU' | fallbackTranslate }}
    </div>
  </div>
</div>
